'use strict';

module.exports = {
  ascending: 'ascending',
  descending: 'descending',
};
